import entities from 'src/config/entities';
import BaseService from "./BaseService";

class ContractService extends BaseService {
  constructor() {
    super({entity: entities.CONTRACT});
  }

  getContractTransactions(params, path) {
    return super.get(params, path);
  }

  async getContracts(params) {
    const filters = [
      {
        "field": "amount",
        "value": 1,
        "operator": ">="
      }
    ]
    const sort = {
      page: params.page || 1,
      limit: params.limit || 10
    }
    if (params.sort) {
      let order = params.sort.charAt(0) === '-' ? 'desc' : 'asc'
      let sortKey = params.sort.substring(1)
      sort.order = {
        [sortKey]: order
      }
    }
    if (params.query) {
      filters.push({
        field: 'search',
        operator: 'LIKE',
        value: params.query
      })
    }
    console.log(sort)
    try {
      let res = await this.instance.post('/filter', {
        filters,
        sort,
        "withs": [
          "client",
          "order",
          "contracts",
          "contracts.order",
          "product_job_board",
          "product_job_board.job_board"
        ]
      });
      return res;
    } catch (e) {
      throw e;
    }
  }

}

export default new ContractService();
